import './App.css';
import {Container} from 'react-bootstrap';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './pages';
import Dashboard from './pages/Dashboard';
import Knowledgebase from './components/Knowledgebase';
import Configure from './components/Configure';
import Deploy from './components/Deploy';
import AgentSettings from './components/Agents/Settings';
import Agent from './components/Agents/Agent';
import Agents from './components/Agents/Agents';
import PrivateRoute from './Routes/PrivateRoute';
import AuthProvider from './context/auth';
import Login from './Routes/Login';
import Home from './components/Home/Home';
import Register from './Routes/Register';
import Organization from './components/Organization';
import SelectOrg from './components/Organization/SelectOrg';
import EmbedChatbotPage from './Public/EmbedChatbotPage';
import Activities from './components/Activity';
import Marketing from './components/Marketing';
import Account from './components/Account';
import OrgSettings from './components/Organization/Settings';
import Support from './components/Account/Support';
import ForgotPassword from './Routes/ForgotPassword';
import ResetPassword from './Routes/ResetPassword';
import ConfirmNewEmail from './components/Account/ConfirmNewEmail';
import JoinOrg from './components/Organization/JoinOrg';
import PricingPage from './pages/Pricing';
import Subscription from './components/Organization/Subscription';
import PaymentSuccess from './components/Organization/Subscription/PaymentSuccess';
import Overview from './pages/Overview';
import QuickStart from './pages/QuickStart';
import Solutions from './pages/Solutions';
import Demo from './pages/Demo';
import PrivacyPolicy from './pages/PrivacyPolicy';
import WhatsApp from './components/Deploy/WhatsApp';
import WebDeployment from './components/Deploy/WebDeployment';
import WhatsAppIntegrationGuide from './components/Deploy/WhatsAppIntegrationGuide';
import { HelmetProvider } from 'react-helmet-async';
import MarketingDashboard from './components/Marketing/test';
import APIDocumentation from './components/Deploy/APIDocumentation';
import APIntegration from './components/Deploy/APIntegration';

function App() {
  return (
	<HelmetProvider>
	<AuthProvider>
    <Container fluid className='dark-theme body-content p-0'>
      	<BrowserRouter> 
			<Routes>
				<Route path='/' element={<HomePage/>}>
					<Route path='' element={<Home/>}/>
					<Route path='pricing' element={<PricingPage/>}/>
					<Route path='overview' element={<Overview/>}/>
					<Route path='quickstart' element={<QuickStart/>}/>
					<Route path='solutions' element={<Solutions/>}/>
					<Route path='demo' element={<Demo/>}/>
					<Route path='whatsapp' element={<WhatsAppIntegrationGuide/>} />
					<Route path='privacy-policy' element={<PrivacyPolicy/>}/>
					<Route path='api-access' element={<APIDocumentation/>}/>

					<Route path='login' element={<Login/>}/>
					<Route path='register' element={<Register/>}/>
					<Route path='/forgot-password' element={<ForgotPassword/>}/>
					<Route path='/reset-password/:resetToken' element={<ResetPassword/>}/>
					<Route path='/confirm-email/:resetToken' element={<ConfirmNewEmail/>}/>
				</Route>
				<Route path='chatagent/:accessKey' element={<EmbedChatbotPage/>} />

				<Route path='/dashboard' element={<PrivateRoute element={<Dashboard/>} />}>
					<Route path='' element={<Organization/>}/>
					<Route path='join-org/:token' element={<JoinOrg/>}/>
					<Route path='orgs' element={<SelectOrg/>}/>
					<Route path='orgs/:orgId/settings' element={<OrgSettings/>}/>
					<Route path='orgs/:orgId/plans' element={<Subscription/>} />
					<Route path='orgs/:orgId/paymentsuccess/:sessionId' element={<PaymentSuccess/>} />
					<Route path='orgs/:orgId' element={<Agents/>}/>
					<Route path='orgs/:orgId/:agentId' element={<Agent/>}>
						<Route path='' element={<Knowledgebase />} />
						<Route path='data' element={<Knowledgebase />} />
						<Route path='configure' element={<Configure />} />
						<Route path='deploy' element={<Deploy/>}>
							<Route path='' element={<WebDeployment/>} />
							<Route path='web' element={<WebDeployment/>} />
							<Route path='whatsapp' element={<WhatsApp/>} />
							<Route path='api' element={<APIntegration/>} />
						</Route>
						{/* <Route path='whatsapp' element={<WhatsApp/>} /> */}
						<Route path='activity' element={<Activities/>} />
						<Route path='marketing' element={<Marketing/>} />
						<Route path='marketing/test' element={<MarketingDashboard/>} />
						<Route path='settings' element={<AgentSettings/>} />
					</Route>

					<Route path='account' element={<Account/>}/>
					<Route path='support' element={<Support/>} />
				</Route>
			</Routes>
      	</BrowserRouter>
    </Container>
	</AuthProvider>
	</HelmetProvider>
  );
}

export default App;
